import { render, staticRenderFns } from "./BindAccountLevelPop.vue?vue&type=template&id=4cc39160&scoped=true&"
import script from "./BindAccountLevelPop.vue?vue&type=script&lang=js&"
export * from "./BindAccountLevelPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc39160",
  null
  
)

export default component.exports